// extracted by mini-css-extract-plugin
module.exports = {"message-container":"message-container__message-container___1-CZJ","message-container--reverse":"message-container__message-container--reverse___1mYyx"};